import React, { Component } from 'react';
import PropTypes from 'prop-types';

import NavigationBar from '../../../common/navigation-bar';

class DailyNewsNavigationBar extends Component {
  constructor(props) {
    super(props);

    const actionsData = this._generateActionsData(props)
    this.state = actionsData;
  }

  componentDidUpdate(props) {
    if (props.url === this.props.url) return;

    this.setState(() => {
      return this._generateActionsData(props);
    });  
  }

  _generateActionsData(props) {
    return {
      previous: {
        link: props.previousInternalUrlId ? `/daily-news/${props.previousInternalUrlId}` : '',
        tooltip: 'previous',
        isDisabled: props.previousInternalUrlId ? false : true 
      },
      next: {
        link: props.nextInternalUrlId ? `/daily-news/${props.nextInternalUrlId}`: '',
        tooltip: 'next',
        isDisabled: props.nextInternalUrlId ? false : true
      },
      all: {
        link: '/daily-news',
        tooltip: 'Back to the list',
        isDisabled: false
      },
    };
  }

  render() {
    return (
      <div className='daily-news-navigation-bar'>
        <NavigationBar {...this.state} />
      </div>
    );
  }  
}

DailyNewsNavigationBar.propTypes = {
  previousInternalUrlId: PropTypes.string,
  nextInternalUrlId: PropTypes.string,  
}

export default DailyNewsNavigationBar;